<template>
    <div class="questionnaire-container questionnaire-multiple row col-sm-7 col-sm-offset-3 col-md-8 col-lg-4 col-md-offset-1 col-lg-offset-4">
        <div class="multiple-question-title form-label col-sm-5 col-md-10 col-lg-10">
            <span>{{label}}</span>
        </div>
        <div class="multiple-options form-label col-sm-5 col-md-10 col-lg-10">
          <div class="multiple-option form-label"
            v-for="(item, index) in options"
            :key="index"
            @click="select(item)"
            >
            <input type="checkbox" :value="item.id" name="option" :checked="internalValueList.includes(item.id)"/>
            <div class="multiple-text">
              {{ item.text }}
            </div>
          </div>
        </div>
        <div v-if="notice" class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-8 notice-text">{{ this.notice }}</div>
        <div v-if="errorMessage || internalErrorMessage" class="col-xs-12 col-sm-7 col-md-7 col-lg-8 error-text">{{ this.internalErrorMessage || this.errorMessage }}</div>
    </div>
</template>
<script>
import { questionnaireMixin } from './mixin.js'
import _ from 'lodash'

export default {

  mixins: [questionnaireMixin],
  props: ['label', 'isEditable', 'notice', 'placeholder', 'options', 'value', 'isRequired', 'errorMessage'],
  components: {
  },
  data () {
    return {
      internalErrorMessage: '',
      internalValueList: []
    }
  },
  model: {
    event: 'change'
  },
  created () {
    this.initValueList(this.value)
  },
  watch: {
    '$i18n.locale' (val) {
      this.validate()
    },
    internalValueList (val) {
      const internalValue = _.join(this.internalValueList, ',')
      this.$emit('change', internalValue)
      this.validate()
    }
  },
  methods: {
    validate () {
      if (this.fieldIsRequired(this.isRequired)) {
        if (this.internalValueList.length === 0) {
          this.internalErrorMessage = this.$t('questionnaire.error.isRequired')
          return false
        }
      }
      this.internalErrorMessage = ''
      return true
    },
    select (item) {
      if (this.internalValueList.includes(item.id)) {
        const index = this.internalValueList.indexOf(item.id)
        this.internalValueList.splice(index, 1)
      } else {
        this.internalValueList.push(item.id)
      }
    },
    initValueList (value) {
      if (!value) {
        return
      }
      const valueList = _.split(value, ',')
      _.forEach(valueList, item => {
        this.internalValueList.push(_.toInteger(item))
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/questionnaire-common.scss';
.questionnaire-multiple {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.2rem;

  .multiple-question-title {
    text-align: left;
    margin-bottom: -8px;
    justify-content: flex-start;
  }
  .multiple-options {
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .multiple-option {
      display: flex;
      align-items: center;
      min-height: unset;
      cursor: pointer;

      input {
        -webkit-appearance: checkbox;
        appearance: checkbox;
        margin-top: 0;
        margin-right: 10px;
      }

      .multiple-text {
        font-size: 1em;
        color: #565656;
        font-weight: 500;
      }
    }

    .multiple-radio-box {
      width: 16px;
      height: 16px;
      background-color: #FFFFFF;
      border: 1px solid #000000;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

}
</style>
